import React from "react";
import './bannerComponent.css'
import { Link } from 'react-router-dom';

const BannerComponent = ({
  url,
  translateText,
  className,
  translateTitle,
  translateTitle2,
  translateButton,
  onClick,
  featured = false,
  chipText,
  hideChip = false,
}) => {
  return (
    <article className={`service-card ${className} ${featured ? "is-featured" : ""}`}>
      <div className="service-card-overlay" />

      <div className="service-card-content">
        {!hideChip && chipText && <span className="service-chip">{chipText}</span>}

        <div className="service-card-body">
          <div className="service-card-text">
            <h2 className="titleBanner">{translateTitle}</h2>
            {translateTitle2 && <h2 className="titleBanner titleBanner2">{translateTitle2}</h2>}
            {translateText && <p className="textBanner">{translateText}</p>}
          </div>

          {translateButton &&
            (onClick ? (
              <button type="button" className="button" onClick={onClick}>
                {translateButton}
              </button>
            ) : (
              <Link to={url} className="button link-button">
                {translateButton}
              </Link>
            ))}
        </div>
      </div>
    </article>
  );
};

export default BannerComponent;